<div cdkTrapFocus cdkTrapFocusAutoCapture="true" class="confirmation-dialog">
  <div class="content">
    @if (data.params) {
      <p class="message">
        {{ data.message | transloco: data.params }}
        @if (data.component) {
          <span>: "{{ data.component | transloco }}"?</span>
        }
      </p>
    }
    @if (!data.params) {
      <p class="message">
        {{ data.message | transloco }}
        @if (data.component) {
          <span>: "{{ data.component | transloco }}"?</span>
        }
      </p>
    }

    @if (data.additionalParams) {
      <ul class="confirmation-dialog_additional-params-list">
        @for (element of data.additionalParams; track element) {
          <li>
            {{ element[0] }}
            <span class="info">{{ element[1] }}</span>
          </li>
        }
      </ul>
    }

    @if (data.checkboxText) {
      <common-checkbox class="confirmation-dialog__checkbox" data-testid="confirmation-dialog_checkbox" [(ngModel)]="isChecked">
        {{ data.checkboxText | transloco }}
      </common-checkbox>
    }

    @if (data.hintText) {
      <p class="confirmation-dialog_hint">{{ data.hintText | transloco }}</p>
    }
  </div>

  <div class="actions">
    <button data-testid="confirmation-dialog_cancel-button" ttButton variant="secondary" (click)="closeDialog(false)">
      <span>{{ data.cancelButtonCaption | transloco }}</span>
    </button>
    @if (data.checkboxText) {
      <div>
        @if (isChecked) {
          <button data-testid="confirmation-dialog_confirm-button" ttButton variant="destructive" (click)="closeDialog(true)">
            <span>{{ data.confirmButtonCaption | transloco }}</span>
          </button>
        }
        @if (!isChecked) {
          <button data-testid="confirmation-dialog_confirm-button" ttButton variant="disabled">
            <span>{{ data.confirmButtonCaption | transloco }}</span>
          </button>
        }
      </div>
    }
    @if (!data.checkboxText) {
      @switch (data.buttonVariant) {
        @case ('destructive') {
          <button
            id="confirm-dialog__accept"
            ttButton
            variant="destructive"
            [attr.data-testid]="data.confirmButtonTestId || 'confirmation-dialog_confirm-button'"
            (click)="closeDialog(true)">
            {{ data.confirmButtonCaption | transloco }}
          </button>
        }
        @default {
          <button
            id="confirm-dialog__accept"
            ttButton
            [attr.data-testid]="data.confirmButtonTestId || 'confirmation-dialog_confirm-button'"
            (click)="closeDialog(true)">
            {{ data.confirmButtonCaption | transloco }}
          </button>
        }
      }
    }
  </div>
</div>
